import { render, staticRenderFns } from "./navBottom.vue?vue&type=template&id=77038135&scoped=true&"
import script from "./navBottom.vue?vue&type=script&lang=js&"
export * from "./navBottom.vue?vue&type=script&lang=js&"
import style0 from "./navBottom.vue?vue&type=style&index=0&id=77038135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77038135",
  null
  
)

export default component.exports